import {Label, TextKpiMedium} from '@hm/fundamental'
import {useTranslation} from 'react-i18next'

interface ShutdownDetailInfoSummaryProps {
  totalAreaSelected: number
  totalWeight: number
  totalCost?: number
}
export const ShutdownDetailInfoSummary = ({
  totalAreaSelected,
  totalWeight,
  totalCost
}: ShutdownDetailInfoSummaryProps) => {
  const {t} = useTranslation()

  return (
    <div className="flex flex-row gap-8">
      <Label title={t('staticParts.editReplacement.summary.area')}>
        <TextKpiMedium>{`${totalAreaSelected.toFixed(2)} m²`}</TextKpiMedium>
      </Label>
      <Label title={t('staticParts.editReplacement.summary.materialWeight')}>
        <TextKpiMedium>{`${totalWeight.toFixed(2)} t`}</TextKpiMedium>
      </Label>
      <Label title={t('staticParts.editReplacement.summary.materialCost')}>
        <TextKpiMedium>{totalCost !== undefined ? `${totalCost.toFixed(2)} $` : '-'}</TextKpiMedium>
      </Label>
    </div>
  )
}
